// AUTO-GENERATED by build-sfx-sprite.js — do not edit manually
// Run "npm run build:sfx" to regenerate
export const SFX_SPRITE_MAP = {
  "basic_win": [
    0,
    2000
  ],
  "big_win": [
    3000,
    2000
  ],
  "button_click": [
    6000,
    500
  ],
  "coin_land": [
    8000,
    1500
  ],
  "free_spin_intro": [
    11000,
    3000
  ],
  "max_win": [
    15000,
    2000
  ],
  "mega_win": [
    18000,
    2000
  ],
  "no_win": [
    21000,
    3000
  ],
  "quick_stop": [
    25000,
    421.133786848074
  ],
  "reel_stop": [
    27000,
    314.5351473922915
  ],
  "scatter_land": [
    29000,
    1500
  ],
  "spin": [
    32000,
    500
  ],
  "super_mega_win": [
    34000,
    2000
  ],
  "total_win": [
    37000,
    4500
  ],
  "trail_sound": [
    43000,
    1000
  ],
  "transition": [
    45000,
    2500
  ],
  "wild_land": [
    49000,
    1000
  ],
  "win_animation_end": [
    51000,
    1494.172335600908
  ],
  "win_line": [
    54000,
    2000
  ],
  "royal_win": [
    57000,
    2000
  ],
  "mini_coin": [
    60000,
    4000
  ],
  "minor_coin": [
    65000,
    4000
  ],
  "midi_coin": [
    70000,
    4000
  ],
  "major_coin": [
    75000,
    4000
  ],
  "grand_coin": [
    80000,
    4000
  ],
  "silver_chest_land": [
    85000,
    1500
  ],
  "gold_chest_land": [
    88000,
    1500
  ],
  "silver_chest_collect": [
    91000,
    500
  ],
  "gold_chest_collect": [
    93000,
    500
  ],
  "scarab_land": [
    95000,
    1500
  ],
  "scarab_activate": [
    98000,
    1500
  ],
  "unlock": [
    101000,
    726.1678004535099
  ],
  "hold_and_win_reel_stop": [
    103000,
    164.96598639456295
  ],
  "hold_and_win_trail": [
    105000,
    1000
  ],
  "respins_counter": [
    107000,
    1000
  ],
  "hold_and_win_coin_land": [
    109000,
    1500
  ],
  "anticipation_end": [
    112000,
    2000
  ],
  "total_win_end": [
    115000,
    1494.172335600908
  ],
  "collector_last": [
    118000,
    7000
  ],
  "collector_hit": [
    126000,
    500
  ],
  "win_scatter": [
    128000,
    2000
  ],
  "win_coin": [
    131000,
    2500
  ],
  "hold_and_win_mini_coin": [
    135000,
    4000
  ],
  "hold_and_win_minor_coin": [
    140000,
    4000
  ],
  "hold_and_win_midi_coin": [
    145000,
    4000
  ],
  "hold_and_win_major_coin": [
    150000,
    4000
  ],
  "hold_and_win_grand_coin": [
    155000,
    4000
  ]
};
